import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
  TextField,
  NumberField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  useListContext,
  Title,
  ListContextProvider,
  Datagrid,
} from 'react-admin';

import { Card, Divider, Tabs, Tab } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import DialogoDeleteResource from './DialogoDeletar';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import { PERMISSAO_TELA_LOCAIS_LISTAR } from '../../utils/dadosTelas';
//import ActionsField from './ActionsField';
import Dialogo from './DialogoCreateEdit';
import Filter from './Filter';

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoCompra = useRef(null);
  const refDialogoDeleteResource = useRef(null);
  const refDialogoConfirmacao = useRef(null);
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);

  function handleCriar() {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleCreate();
    }
  }
  function handleEdit({ id }) {
    if (refDialogoCompra.current) {
      refDialogoCompra.current.handleEdit(id);
    }
  }

  function handleClose() {
    refresh();
  }

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Local',
        'Deseja realmente reativar este Local?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Local',
        'Deseja realmente desativar este Local?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Local',
        'Deseja deletar permanentemente este Local?',
        { id, codigo: 3 },
      );
    }
  }

  async function ativar(id) {
    await api.put(`/locais_setores/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/locais_setores/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/locais_setores/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  return (
    <>
      <Title title="Locais" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props}>
                <TextField source="nome" label="Descrição" />
                <NumberField
                  source="area"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    currency: 'BRL',
                  }}
                  label="Área (m2)"
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*      handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => handleEdit(record),
                    },
                    {
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleAtivar(record),
                    },
                    {
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      show: (record) => record.status === STATUS_ATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleDesativar(record),
                    },
                    {
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleDeletar(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props}>
                <TextField source="nome" label="Descrição" />
                <NumberField
                  source="area"
                  options={{
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    currency: 'BRL',
                  }}
                  label="Área (m2)"
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  /*            handleEdit={handleEdit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar} */
                  actions={[
                    {
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      show: () => true,
                      disabled: () => false,
                      onClick: (record) => handleEdit(record),
                    },
                    {
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleAtivar(record),
                    },
                    {
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      show: (record) => record.status === STATUS_ATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleDesativar(record),
                    },
                    {
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      show: (record) => record.status === STATUS_INATIVO,
                      disabled: (record) =>
                        record.user_id === 1 || record.user_id === 2,
                      onClick: (record) => handleDeletar(record),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogoCompra} handleClose={handleClose} />
      <DialogoDeleteResource ref={refDialogoDeleteResource} />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_LOCAIS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Locais"
      filterDefaultValues={{
        status: STATUS_ATIVO,
      }}
    />
  </ProtegerPagina>
);

export default List2;
